import { Button, Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import SelectDictSearch from '../../../common/inputs/SelectDictSearch.jsx'
import { useEffect, useState } from 'react'
import { useEdytujOperatora } from '../../../../api/domain/osoby/mutations/useEdytujOperatora.jsx'
import { usePozycjeSlownika } from '../../../../api/domain/slowniki/queries/usePozycjeSlownika.jsx'
import { Checkbox } from '../../../common/inputs/index.js'

export const ModalEdytujOsobe = ({ currPozycja, show, handleClose }) => {
    const [form, setForm] = useState({
        czy_manager: currPozycja?.czy_manager,
        slownik_team_id: currPozycja?.slownik_team_id,
        slownik_subteam_id: currPozycja?.slownik_subteam_id,
        email: currPozycja?.email,
        id: currPozycja?.id,
        name: currPozycja?.name,
    })

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        })
    }

    const handleOnClose = () => {
        handleClose()
    }

    useEffect(() => {
        setForm({
            czy_manager: currPozycja?.czy_manager,
            slownik_team_id: currPozycja?.slownik_team_id,
            slownik_subteam_id: currPozycja?.slownik_subteam_id,
            name: currPozycja?.name,
            email: currPozycja?.email,
            id: currPozycja?.id,
        })
    }, [currPozycja])
    const zmien = useEdytujOperatora()
    const teams = usePozycjeSlownika('teams')
    const subteams = usePozycjeSlownika('subteams')

    return (
        <Modal size={'lg'} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Edytowanie osoby:{' '}
                    {currPozycja?.imie + ' ' + currPozycja?.nazwisko}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div
                    style={{ width: '100%' }}
                    className={'d-flex flex-column w-100 gap-3'}
                >
                    <Checkbox
                        className={'align-self-start'}
                        title={'Czy kierownik/koordynator'}
                        onChange={(e) =>
                            setField(
                                'czy_manager',
                                e.target.checked ? 'Tak' : 'Nie'
                            )
                        }
                        value={form.czy_manager}
                        label={'Czy kierownik/koordynator'}
                    />
                    <SelectDictSearch
                        options={teams.data?.map((team) => ({
                            ...team,
                            value: team.id,
                            label: team.nazwa,
                        }))}
                        addKey={'id'}
                        value={form.slownik_team_id}
                        label={
                            'Team/Referat/Zespół (jeśli podlega pod dyrektora)'
                        }
                        onChange={(e) => setField('slownik_team_id', e?.value)}
                    />
                    <SelectDictSearch
                        options={subteams.data?.map((subteam) => ({
                            ...subteam,
                            value: subteam.id,
                            label: subteam.nazwa,
                        }))}
                        addKey={'id'}
                        value={form.slownik_subteam_id}
                        label={'Zespół/Podreferat'}
                        onChange={(e) =>
                            setField('slownik_subteam_id', e?.value)
                        }
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleOnClose}>
                    Anuluj
                </Button>
                <Button
                    variant='success'
                    onClick={() => {
                        zmien.mutate(form)
                        handleOnClose()
                    }}
                >
                    Zapisz zmiany
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalEdytujOsobe.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}

export const ModalZarzadzajZastepstwo = ({
    currPozycja,
    show,
    handleClose,
}) => {
    const handleOnClose = () => {
        handleClose()
    }

    const zmien = useEdytujZastepstwoKierownika()
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Zarządzanie zastępstwem:{' '}
                    {currPozycja?.imie + ' ' + currPozycja?.nazwisko}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Zamierzasz zmienić zastępstwo kierownicze. Zmiana ta będzie
                miała wpływ na dostępność do niektórych zasobów i możliwość
                edytowania niektórych danych. Czy na pewno chcesz kontynuować?
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleOnClose}>
                    Anuluj
                </Button>
                <Button
                    variant='success'
                    onClick={() => {
                        zmien.mutate({
                            id: currPozycja.id,
                            name: currPozycja.name,
                            nadaj: currPozycja.czy_manager !== 'Tak',
                        })
                        handleOnClose()
                    }}
                >
                    Zmień
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalZarzadzajZastepstwo.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func,
}
